export default __webpack_public_path__ + "assets/audio/炎.56f3e7da.m4a";